import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-notification@3.2.0@rc-notification/es/index.js
// module id = 311
// module chunks = 0 1